export default __webpack_public_path__ + "static/media/background-school-mobile.cede2c56.svg";